import cookies from "js-cookie";
import ROUTES from "constants/routes";
import dayjs from "dayjs";

export const AUTH_STATE_CHANGE_EVENT = "myhrbox:auth-state-change";

interface ICookie {
  name: string;
  value: string;
  options?: object;
}

const setCookie = (cookie: ICookie) => {
  cookies.set(cookie.name, cookie.value, {
    expires: dayjs().add(30, "d").toDate(),
    ...cookie.options,
  });
};

const emitAuthStateChange = () => {
  window.dispatchEvent(new Event(AUTH_STATE_CHANGE_EVENT));
};

export const setAuthCookies = (_cookies: ICookie | ICookie[] = []) => {
  if (Array.isArray(_cookies)) {
    _cookies.forEach((cookie) => setCookie(cookie));
  } else setCookie(_cookies);

  emitAuthStateChange();
};

export const removeAllCookies = () => {
  const allCookies = cookies.get();

  Object.keys(allCookies).forEach((name) => {
    cookies.remove(name);

    cookies.remove(name, {
      domain: window.location.hostname,
      path: "/",
    });
  });

  emitAuthStateChange();
};

export const authRedirect = ({
  accessToken,
  refreshToken,
  redirectUrl,
}: {
  accessToken?: string;
  refreshToken?: string;
  redirectUrl: string;
}) => {
  if (accessToken && refreshToken) {
    setAuthCookies([
      { name: "accessToken", value: accessToken },
      { name: "refreshToken", value: refreshToken },
    ]);
  }
  document.location.href = redirectUrl || `${window.location.origin}/${ROUTES.COMPETENCE_MAPS}`;
};
